import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

type ExportOptions = {
  fileName: string;
  sheetName?: string;
};

export const exportToExcel = (
  rows: Record<string, any>[],
  options: ExportOptions
) => {
  if (!rows || rows.length === 0) return;

  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    options.sheetName ?? "Sheet1"
  );

  const buffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([buffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });

  saveAs(blob, `${options.fileName}.xlsx`);
};